import type { Language } from "@heredajo/schema";
import { ALL_LANGS, LANG_LABEL } from "../lib/i18n.js";

interface Props {
  value: Language;
  onChange: (lang: Language) => void;
  label: string;
}

export function LanguageSelector({ value, onChange, label }: Props): JSX.Element {
  return (
    <label className="text-sm flex items-center gap-2">
      <span className="opacity-70">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as Language)}
        className="bg-ink-muted text-parchment-100 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-parchment-300"
      >
        {ALL_LANGS.map((lang) => (
          <option key={lang} value={lang}>
            {LANG_LABEL[lang]}
          </option>
        ))}
      </select>
    </label>
  );
}
